import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppThemeService {
  constructor(private http: HttpClient) {}

  async loadTheme() {
    try {
      const config: any = await this.http
        .get('assets/config/app-config.json')
        .toPromise();

      const theme = config && config.theme ? config.theme : null;

      if (!theme) return;

      document.documentElement.style.setProperty('--app-primary-color', theme.primaryColor || '#009F60');
      document.documentElement.style.setProperty('--app-primary-dark-color', theme.primaryDarkColor || '#007A49');
      document.documentElement.style.setProperty('--app-primary-light-color', theme.primaryLightColor || '#E6F5EF');
      document.documentElement.style.setProperty('--app-primary-contrast-color', theme.primaryContrastColor || '#ffffff');
      document.documentElement.style.setProperty('--app-primary-chip-bg-color', theme.primaryChipBgColor || '#009f5f9a');
      document.documentElement.style.setProperty('--login-background-color', theme.loginBackgroundColor || '#d5ffee');

    } catch (err) {
      console.warn('Theme config not loaded. Using default theme.', err);
    }
  }
}